<div class="container-fluid widget-wrapper" *ngIf="data?.overview?.ownerDomain != 'N/A'">
  <div class="row widget-header">
    <div class="col-lg-12">
      <h2>Domain Details
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
          title="Key platform specific details for each domain">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12">
      <domain-more-details [data]="data" [os]="os" [region]="region" [device]="device"
        (anchorClick)="anchorClick.emit($event)" (toAppDiscovery)="toAppDiscovery.emit($event)"></domain-more-details>
    </div>
  </div>
</div>
<div class="container-fluid" id="domain-mfa">
  <div class="row justify-content-between">
    <div class="col-xl-6 mt-4 widget-wrapper" *ngIf="data.mfa">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>
            Made for Advertising (MFA) Risk
            <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
          </h2>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-mfa [data]="data" [os]="os" [region]="region" [device]="device"
            (anchorClick)="anchorClick.emit($event)" (toAppDiscovery)="toAppDiscovery.emit($event)">
          </domain-mfa>
        </div>
      </div>
    </div>
    <div class="col-xl-6 mt-4 widget-wrapper" *ngIf="data.riskOverview.givtSivtRateRating !== 'N/A'
          && data.riskOverview.clickFraudRiskScore !== 'N/A'
          && data.riskOverview.nonGivtSivtViewabilityRating !== 'N/A'
          && data.riskOverview.maskingRatioRating !== 'N/A'
          && data.riskOverview.majorTrafficSource !== 'N/A'">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>Traffic Quality Risk
          </h2>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-traffic-quality-risk [data]="data" [os]="os" [region]="region" [device]="device"
            (anchorClick)="anchorClick.emit($event)" (toAppDiscovery)="toAppDiscovery.emit($event)">
          </domain-traffic-quality-risk>
        </div>
      </div>
    </div>
    <div class="col-xl-6 mt-4 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>Site Risk
          </h2>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-site-risk [data]="data" [os]="os" [region]="region" [device]="device"
            (anchorClick)="anchorClick.emit($event)" (toAppDiscovery)="toAppDiscovery.emit($event)">
          </domain-site-risk>
        </div>
      </div>
    </div>
    <div class="col-xl-6 mt-4 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>Site information
          </h2>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-site-information [data]="data" [os]="os" [region]="region" [device]="device"
            (anchorClick)="anchorClick.emit($event)" [isFollowing]="isFollowing"
            (toAppDiscovery)="toAppDiscovery.emit($event)">
          </domain-site-information>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt-4">
  <div class="row justify-content-between">
    <div class="col-xl-6 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>Brand Safety Risk
            <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
              title="Risk levels for our brand safety categories are assessed at the homepage (root domain) level">
              <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
            </a>
          </h2>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-brand-safety-risk [data]="data" [os]="os" [region]="region" [device]="device"
            (anchorClick)="anchorClick.emit($event)" (toAppDiscovery)="toAppDiscovery.emit($event)">
          </domain-brand-safety-risk>
        </div>
      </div>
    </div>
    <div class="col-xl-6 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>Social Media Engagement
            <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
              title="Active engagement levels for various social platforms">
              <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
            </a>
          </h2>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-social-media [data]="data" [os]="os" [region]="region" [device]="device"
            (anchorClick)="anchorClick.emit($event)" (toAppDiscovery)="toAppDiscovery.emit($event)">
          </domain-social-media>
        </div>
      </div>
    </div>
  </div>
</div>